/**
 * XEP-0313 archive results arrive as their own stanzas, one per row:
 *
 * ```
    <message to="9250@skunk_works/web" from="9250@skunk_works">
      <result xmlns="urn:xmpp:mam:2" id="1787637303882115" queryid="q1">
        <forwarded xmlns="urn:xmpp:forward:0">
          <delay xmlns="urn:xmpp:delay" stamp="2026-06-19T09:52:11.630778Z"/>
          <message to="10623@skunk_works" from="9250@skunk_works/other-tab"
                   type="chat" id="out-1" xmlns="jabber:client">
            <body>hei</body>
          </message>
 * ```
 *
 * The envelope is addressed you-to-you and names no conversation; the routing
 * that matters is on the forwarded message.
 */
import type { Element as XmlEl } from "@xmpp/xml"
import { NS_CLIENT, NS_DELAY, NS_FORWARD, NS_MAM } from "../../constants"
import { hoist } from "../../xmlUtils"

/** The archived message, or null when this isn't a MAM result. */
export function unwrapMamResult(xml: XmlEl): XmlEl | null {
  const forwarded = xml
    .getChild("result", NS_MAM)
    ?.getChild("forwarded", NS_FORWARD)
  if (!forwarded) return null

  const message = forwarded.getChild("message", NS_CLIENT)
  if (!message) return null

  // The archive's stamp sits beside the message, not inside it.
  hoist(forwarded, message, "delay", NS_DELAY)

  return message
}
